<template>
  <div>
    <h3
      style="text-transform: uppercase; margin-bottom: 12px; margin-top: 28px;"
    >
      Campaign Dates
    </h3>
    <form action="" @submit.prevent="submitForm()">
      <div style="display: flex; align-items: center;">
        <div class="form-group" style="flex: 1;">
          <div class="date-time-picker-container inline">
            <DateTimePicker
              color="#13a3eb"
              class="mr-sm-2"
              formatted="DD MMM YYYY"
              format="YYYY-MM-DD"
              autoClose
              input-size="sm"
              noClearButton
              noButton
              only-date
              v-model="startDate"
              id="start-date"
            >
            </DateTimePicker>
          </div>
          <label style="letter-spacing: 0px; font-size: 12px;" for="start-date"
            >Start Date:</label
          >
        </div>
        <div
          style="height: 16px; width: 16px; margin: 0px 8px;transform: translateY(-6px);"
        >
          <arrow-right></arrow-right>
        </div>
        <div class="form-group" style="flex: 1;">
          <div class="date-time-picker-container inline">
            <DateTimePicker
              color="#13a3eb"
              class="mr-sm-2"
              formatted="DD MMM YYYY"
              format="YYYY-MM-DD"
              autoClose
              input-size="sm"
              noClearButton
              noButton
              only-date
              v-model="endDate"
            >
            </DateTimePicker>
          </div>
          <label style="letter-spacing: 0px; font-size: 12px;">End Date:</label>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div class="form-group" style="flex: 1">
          <input
            name="date-note"
            id="date-note"
            class="form-control mb-2"
            required
            v-model="note"
          />
          <label style="letter-spacing: 0px; font-size: 12px;"
            ><span style="color: red;">*&nbsp;</span>Update Note:</label
          >
        </div>
        <button
          class="btn btn-primary mb-2"
          :disabled="!note"
          type="submit"
          style="padding: 0px 10px;height: 35px;border-radius: 0px;transform: translateY(-3px);"
        >
          Update
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import DateTimePicker from 'vue-ctk-date-time-picker';
import ArrowRight from '../../assets/icons/arrow-right.vue';
import CampaignServiceV2 from '../../services/V2/CampaignServiceV2';
import {format, subDays, parse, addDays} from 'date-fns';

export default {
  data() {
    return {
      note: null,
    };
  },
  props: ['id', 'startDate', 'endDate', 'status'],
  components: {
    DateTimePicker,
    ArrowRight,
  },
  methods: {
    async submitForm() {
      try {
        const payload = {
          startDate: format(this.startDate, 'YYYY-MM-DD'),
          endDate: format(this.endDate, 'YYYY-MM-DD'),
          note: this.note,
        };

        await CampaignServiceV2.adjustCampaignDates(this.id, payload);

        this.note = null;

        this.$emit('on-campaign-dates-updated');

        this.$swal({
          type: 'success',
          title: 'Campaign Dates Adjusted',
          text: 'Campaign dates been adjusted successfully.',
        });
      } catch (error) {
        this.$swal({
          type: 'error',
          title: 'Error',
          text: 'Failed to update campaign dates.',
        });
      }
    },
  },
};
</script>
